export enum AllExcludeOnlyEnum {
  exclude = 'exclude',
  all = 'all',
  only = 'only'
}

export const AllExcludeOnlyLabels = {
  [AllExcludeOnlyEnum.exclude]: 'Exclude',
  [AllExcludeOnlyEnum.all]: 'All',
  [AllExcludeOnlyEnum.only]: 'Only'
}
